import React from 'react'
import {
  useCheckoutFormShippingState,
  useLocalLabels,
} from '@sentecacommerce-theme/lib'
import { CheckoutAddressForm, CheckoutDeliveryForm } from './Components'
import { CheckoutLabels } from '../../checkout.props'
import {
  AddressBookPreview,
  Button,
  Spinner,
  IconPlus,
  FormError,
} from '../../../Common'
import styled from 'styled-components'

export const CheckoutShipping = ({ setEmail }: any) => {
  const {
    savedAddressList,
    isSavedAddressListEnabled,
    isAddingNew,
    updateIsAddingNew,
    isValid,
    isSubmitting,
    hasAvailableSavedAddress,
  } = useCheckoutFormShippingState()

  const labels = useLocalLabels<CheckoutLabels>()

  if (isSavedAddressListEnabled && !savedAddressList) {
    return (
      <SpinnerContainer>
        <Spinner />
      </SpinnerContainer>
    )
  }

  if (isAddingNew || !isSavedAddressListEnabled || !hasAvailableSavedAddress) {
    return (
      <InputsWrapper>
        <CheckoutDeliveryForm />
        <CheckoutAddressForm setEmail={setEmail} />
      </InputsWrapper>
    )
  }

  return (
    <InputsWrapper>
      <div className="col-12">
        {savedAddressList?.map((address) => {
          if (!address.isSelectable) return null

          return (
            <div key={address._id} className="mb-4">
              <AddressBookPreview
                onChange={address.select}
                isSelected={address.isSelected}
                data={address}
                isSelectable
                hideRemove
              />
            </div>
          )
        })}
        {!isValid && isSubmitting && (
          <div>
            <FormError text={labels?.validations?.saveOrAddNewAddress} />
          </div>
        )}
      </div>

      <div className="col-12">
        <div className="pt-1">
          <Button
            variant="primary"
            bordered
            small
            onClick={() => updateIsAddingNew(true)}
            borderRadius="small"
          >
            <span className="d-flex align-items-center">
              <IconPlus width="1.5rem" className="mr-2" />
              <span>{labels?.addNewAddress}</span>
            </span>
          </Button>
        </div>
      </div>
    </InputsWrapper>
  )
}

const SpinnerContainer = styled.div.attrs({
  className: 'd-flex align-items-center justify-content-center',
})`
  min-height: 50rem;
  position: relative;
`

const InputsWrapper = styled.div.attrs({
  className: 'row g-4',
})`
  & input {
    border-radius: 0;
  }
`
